var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import RootCloseWrapper from 'react-overlays/lib/RootCloseWrapper';
import CheckboxMenu from './CheckboxMenu';
var CheckboxDropdownMenu = React.forwardRef(function (_a, ref) {
    var open = _a.open, onClose = _a.onClose, rootCloseEvent = _a.rootCloseEvent, props = __rest(_a, ["open", "onClose", "rootCloseEvent"]);
    return (_jsx(RootCloseWrapper, __assign({ disabled: !open, onRootClose: function (e) { return onClose(e, { source: 'rootClose' }); }, event: rootCloseEvent, ref: ref }, { children: _jsx(CheckboxMenu, __assign({}, props, { className: "dropdown-menu" })) })));
});
export default CheckboxDropdownMenu;
